<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      //
    };
  }
};
</script>
<style lang="scss">
body{
  overflow: scroll!important;
}
html{
  //overflow: auto!important;
}
</style>